module.exports = __webpack_public_path__ + "static/media/VestasSans-Thin.52539e80.woff";